// extracted by mini-css-extract-plugin
export default {"Label":"AddPost_Label__+In2X","Image":"AddPost_Image__xSlR5"};